import React, { useState,useEffect,useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import axios from '../../plugins/axios'
import moment from "moment";

import TrendWave from './trendform/trendWave';
import Tabular from './trendform/tabular';
import Strip from './trendform/strip';

import "./A4.scss";

// Trend URL Parameter 정리, deviceId, startdate,enddate,selectDate
const TrendForm = () => {
    const { t, i18n } = useTranslation()
    const [searchParams] = useSearchParams();
    const isFirstRender = useRef(true);
    const [queryParams, setQueryParams] = useState({})    
    const [deviceInfo, setDeviceInfo] = useState() // 선택한 디바이스 정보  
    const [patientInfo, setPatientInfo] = useState() // 선택한 환자 정보 
    const [patientHistories, setPatientHistories] = useState()  
    const [patientLatestHistory, setPatientLatestHistory] = useState(null)
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isPageReady, setIsPageReady] = useState(false);    

    //Report Info 정보 가져오기
    const getReportInfo = async () => {
         try {
            // 사용자 정보 가져오기
            const res = await axios.get('/user/me')
            if (res.code != '200') throw res

            //언어 세팅
            i18n.changeLanguage(res.data.language);

            const deviceId = queryParams.deviceId // 디폴트 값 설정 

            const resDevice = await axios.get(`/device/${deviceId}`);
            if (resDevice.code != '200') throw resDevice

            setDeviceInfo(resDevice.data);

            //과거 시간의 데이터를 가져와야 할 수 있어서 device 기준이 아닌 그때 시간의 기준으로 데이터를 가져온다.
            const resHistory = await axios.get(`/device/${queryParams.deviceId}/patient/histories?startDate=${moment.utc(queryParams.selectTime).format('YYYY-MM-DDTHH:mm:ss')}Z&endDate=${moment.utc(queryParams.selectTime).format('YYYY-MM-DDTHH:mm:ss')}Z`);
            if (resHistory.code != '200') throw resHistory
                    
            const latestHistory = resHistory?.data?.latestHistory;
            if(latestHistory?.patientId == null || latestHistory?.patientId == undefined){
                setPatientInfo({
                    name : 'Not Admitted',
                });
            }else{
                if(latestHistory.action == 'UNASSIGNED'){
                    setPatientInfo({
                        name : 'Not Admitted',
                    });                    
                }else{
                    const resPatient = await axios.get(`/patient/${latestHistory?.patientId}`);
                    if (resPatient.code != '200') throw resPatient
                    
                    setPatientInfo(resPatient.data);     
                }
            }         
        } catch (patientError) {
            console.warn('환자 정보 가져오기 실패:', patientError);
        }
    }

    // 환자 히스토리.
    const getPatientHistory = async () => {
        try {
            const res = await axios.get(`/device/${deviceInfo?.id}/patient/histories?startDate=${moment.utc(queryParams.startTime).format('YYYY-MM-DDTHH:mm:ss')}Z&endDate=${moment.utc(queryParams.endTime).format('YYYY-MM-DDTHH:mm:ss')}Z`)
            if (res.code != '200') throw res
            setPatientHistories(res.data.histories)     
            setPatientLatestHistory(res.data.latestHistory);
            return true;
        } catch (err) { 
            console.warn(err) 
            return false;
        }
    }

    // 프린터 함수
    const handlePrint = () => {
        console.log('프린트 시작');
        
        // 클래스 제거 후 다시 추가 (리프레시 효과)
        document.documentElement.classList.remove("waveform-active");
        document.body.classList.remove("waveform-active");
        
        setTimeout(() => {
            document.documentElement.classList.add("waveform-active");
            document.body.classList.add("waveform-active");
            
            setTimeout(() => {
                console.log('페이지 수:', document.querySelectorAll('.a4-page').length);
                window.print();
            }, 500);
        }, 100);
    };

    useEffect(() => {
        setQueryParams({
            deviceId: searchParams.get('deviceid'),
            startTime: searchParams.get('starttime'),
            endTime: searchParams.get('endtime'),
            selectTime: searchParams.get('selecttime'),
            leadType: searchParams.get('leadtype'),
            type: searchParams.get('type'),
            wave1: searchParams.get('wave1'),
            wave2: searchParams.get('wave2'),
        });        

        //Page 스타일링
        const style = document.createElement("style");
            style.innerHTML = `
            @page {
                size: 3508px 2480px;
                margin: 0;
            }
            `;
        document.head.appendChild(style);

        // 스타일 클래스 추가
        document.documentElement.classList.add("waveform-active");
        document.body.classList.add("waveform-active");        

        return () => {
            document.documentElement.classList.remove("waveform-active");
            document.body.classList.remove("waveform-active");
            document.head.removeChild(style); // 라우트 빠져나갈 때 제거
        };
    }, []);

    useEffect(() => {
        if(isFirstRender.current){
            isFirstRender.current = false;
            return;
        }

        console.log('queryParams : ', queryParams);
        getReportInfo(); //Device & Patient정보 가져오기.
    }, [queryParams])

    useEffect(() => {
        if(deviceInfo){
            const loadAllData = async () => {
                //console.log('데이터 로딩 시작...');
                
                try {
                    // 모든 비동기 작업을 병렬로 실행
                    const [patientHistory] = await Promise.all([
                        getPatientHistory() //환자 history 가져오기
                    ]);

                    if (patientHistory) {
                        console.log('모든 데이터 로딩 완료');
                        setIsDataLoaded(true);
                    } else {
                        console.error('데이터 로딩 실패');
                    }
                } catch (error) {
                    console.error('데이터 로드 중 에러:', error);
                }
            };
            loadAllData();

        }
    }, [deviceInfo])

    useEffect(() => {
        if (isDataLoaded) {
            // DOM 렌더링 및 Canvas 그리기 완료를 위한 충분한 대기 시간
            const renderTimer = setTimeout(() => {
                //console.log('페이지 렌더링 완료');
                setIsPageReady(true);
            }, 1500); // Canvas 렌더링을 고려한 여유 시간

            return () => clearTimeout(renderTimer);
        }
    }, [isDataLoaded]);

    // 페이지 준비 완료 시 자동 프린트
    useEffect(() => {
        if (isPageReady) {
            // URL 파라미터로 자동 프린트 제어
            const urlParams = new URLSearchParams(window.location.search);
            const autoPrint = urlParams.get('autoPrint');
            const delay = parseInt(urlParams.get('delay')) || 3000;
            
            if (autoPrint === 'true' || autoPrint === null) { // 기본값은 자동 프린트
                setTimeout(() => {
                    handlePrint(); // 자동 프린트 잠시 스탑
                }, delay);
            }
        }
    }, [isPageReady]);

    //인쇄 하거나 취소하고 창 꺼지기
    window.onafterprint = () => {
        setTimeout( () => {
            window.close();
        },1000)
    };

    // 스타일 정의
    const patientInfoFontBold = 'text-black font-medium text-[48px] leading-[110%] font-pretendard';
    const patientInfoFont = 'text-black font-thin text-[36px] leading-[40px] font-pretendard';

    return (
        <div className="document-container bg-gray-100 p-20 font-sans min-h-screen">
            <div className="a4-page-landscape mx-auto bg-white shadow-lg relative box-border">
                <div className="w-full h-full flex flex-col px-[146px] pt-[140px] pb-[66px]">                    
                    <div>
                        <div className="w-full flex flex-col pb-[24px] border-b-[4px] border-[#5E5E5E] ">
                            <div className='w-full flex items-center justify-start gap-[122px]'>
                                <div className="flex">
                                    <strong className={patientInfoFontBold}>{t("print.common.patientId")} : </strong>
                                    <strong className={patientInfoFontBold}>&nbsp;{patientInfo?.devicePatientId || '---'}</strong>
                                </div>
                                <div className="flex">
                                    <strong className={patientInfoFontBold}>{t("print.common.name")} : </strong>
                                    <strong className={patientInfoFontBold}>&nbsp;{patientInfo?.name || '---'}</strong>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex items-center justify-between py-[32px] border-b-[4px] border-[#5E5E5E]/50 mb-[80px]'>
                            <div className="flex">
                                <span className={patientInfoFont}>{t("print.common.admitted")} : </span>
                                <span className={patientInfoFont}>&nbsp;{patientInfo?.createdAt ? moment(patientInfo?.createdAt).format('YYYY-MM-DD HH:mm') : '---'}</span>
                            </div>
                            <div className="flex">
                                <span className={patientInfoFont}>{t("print.common.category")} : </span>
                                <span className={patientInfoFont}>&nbsp;{patientInfo?.category || '---'}</span>
                            </div>
                            <div className="flex">
                                <span className={patientInfoFont}>{t("print.common.dateOfBirth")} : </span>
                                <span className={patientInfoFont}>&nbsp;{patientInfo?.birthDate || '---'}</span>
                            </div>
                            <div className="flex">
                                <span className={patientInfoFont}>{t("print.common.gender")} : </span>
                                <span className={patientInfoFont}>&nbsp;{patientInfo?.gender === 'M' ? t('print.common.male') : patientInfo?.gender === 'F' ? t('print.common.female') : t('print.common.notSelected')}</span>
                            </div>
                            <div className="flex">
                                <span className={patientInfoFont}>{t("print.common.height")}/{t("print.common.weight")} : </span>
                                <span className={patientInfoFont}>&nbsp;{patientInfo?.height || '0'}cm / {patientInfo?.weight || '0'}kg</span>
                            </div>
                        </div>                        
                    </div>
                    {/* Content */}
                    <div className="mb-[25px]">
                        <div className="relative mb-[40px]">
                            <strong className={`${patientInfoFontBold} !text-[40px]`}>ECG {queryParams?.leadType || '-'}</strong>
                        </div>
                        {
                            deviceInfo && patientHistories &&
                                <TrendWave 
                                    deviceInfo={deviceInfo}
                                    startTime={queryParams?.startTime}
                                    endTime={queryParams?.endTime}
                                    selectTime={queryParams?.selectTime}
                                    leadType={queryParams?.leadType}
                                    patientHistories={patientHistories} 
                                />
                        }
                    </div>
                    <div className="w-full flex items-center justify-end ">                        
                        <div>
                            <span className="text-black text-center font-pretendard text-[24px] font-medium leading-[110%]">(1/2)</span>
                        </div> 
                    </div>
                </div>
            </div>
        
            {
                queryParams && queryParams.type == 'tabular' && deviceInfo && (
                    <Tabular 
                        deviceInfo={deviceInfo}
                        startTime={queryParams?.startTime}
                        endTime={queryParams?.endTime}
                        selectTime={queryParams?.selectTime}
                    />
                )
            }

            {
                queryParams && queryParams.type == 'strip' && deviceInfo && (
                    <Strip 
                        deviceInfo={deviceInfo}
                        startTime={queryParams?.startTime}
                        endTime={queryParams?.endTime}
                        selectTime={queryParams?.selectTime}
                        wave1={queryParams?.wave1}
                        wave2={queryParams?.wave2}
                    />
                )
            }
        </div>
    )
}

export default TrendForm


